
import {  add, getUnixTime, nextDay } from 'date-fns';
import { ExpressionArg } from 'survey-engine/data_types';
import { AutoMessage, AutoMessageType, TimeRecipe, TimeExpression, NextTimeDefinition, DayName } from '../../../api/types/messages';

export interface AutoMessageRecipe {
    label: string // Internal label
    recipe: AutoMessageRecipeDefinition // Value to use for the automessage configuration
    forceTemplateType?: string; // Force override of message type when applying the recipe (to bypass the weekday check for example)
}
 
export interface AutoMessageRecipeDefinition {
  label?: string;
  studyKey?: string;
  condition?: ExpressionArg;
  nextTime?: TimeRecipe // Can be fixed timestamp or relative time description using a "recipe"
  until?: TimeRecipe
  period?: number;
  type?: AutoMessageType
};


export const fromRecipe = (recipe: AutoMessageRecipeDefinition): Partial<AutoMessage> => {

  const m : Partial<AutoMessage> = {};

  if(recipe.condition) {
    m.condition = recipe.condition;
  }
  
  if(recipe.label) {
    m.label = recipe.label;
  }

  if(recipe.studyKey) {
    m.studyKey = recipe.studyKey;
  }

  if(recipe.type) {
    m.type = recipe.type;
  }

  if(recipe.period) {
    m.period = recipe.period;
  }

  if(recipe.nextTime) {
    m.nextTime = recipe.nextTime;
  }

  if(recipe.until) {
    m.until = recipe.until;
  }
  return m;
}

/**
 * Compute timestamp from a relative time recipe
 * @param r 
 * @param now 
 * @returns 
 */
export const fromTimeRecipe = (r: TimeRecipe, now: Date): number => {
  if(typeof(r) == "number") {
    return r;
  }
  const d = recipeToDate(r, now);
  return getUnixTime(d);
}

/**
 * Compute js Date from a relative time Recipe
 * @param r 
 * @param now 
 * @returns 
 */
const recipeToDate = (r: TimeExpression, now: Date): Date => {
  if('next' in r) {
    return nextTime(r.next, now);
  }
  if('in' in r) {
    const d = add(now, r.in);
    return d;
  }
  throw new Error("in or next must be set");
}


const nextTime =(r: NextTimeDefinition, now: Date):Date =>  {
  var d = new Date(now);
  if( typeof(r.day)  == "string") {
     const day = Days[r.day] ?? undefined;
     if(day === undefined) {
      throw Error("Unknown day '"+ r.day +"'");
     }
     if( d.getDay() !== day ) {
        d = nextDay(d, day);
     }
  }
  if( typeof(r.hour) == "number" ) {
      d.setHours(r.hour);
  }
  if(typeof(r.minute) == "number") {
      d.setMinutes(r.minute);
  }
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d;
}

const Days : Record<DayName, Day> = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday:4,
  friday: 5,
  saturday: 6,
  sunday: 0
} as const;
